export const getBreadcrumbsLabels = (breadcrumbs = [], keyword) => {

  let mutableBreadcrumbs = (Array.isArray(breadcrumbs)) ? [...breadcrumbs] : [];

  if (keyword) {
    const textSearchCrumb = {
      label: 'Text Search'
    };

    let label;
    try {
      label = decodeURI(keyword);
    } catch (err) {
      label = keyword;
    }
    const keywordCrumb = {
      label
    };
    if (!mutableBreadcrumbs.length) {
      mutableBreadcrumbs.unshift(textSearchCrumb, keywordCrumb);
    } else {
      const textSearchCrumbIndex = mutableBreadcrumbs.findIndex((crumb) => {
        return crumb.label === textSearchCrumb.label;
      });
      if (textSearchCrumbIndex === -1) {
        mutableBreadcrumbs.unshift(textSearchCrumb, keywordCrumb);
      }
    }
  }
  if (mutableBreadcrumbs.length > 0) {
    const hasCategory = mutableBreadcrumbs
      .filter((crumb) => (crumb.dimensionName || '').toLowerCase() === 'category').length > 1;

    return hasCategory ? mutableBreadcrumbs
      .filter((crumb) => crumb?.dimensionName?.toLowerCase() === 'category')
      .map((crumb) => crumb?.label?.toLowerCase())
      .join('>')
      : mutableBreadcrumbs.map((crumb) => crumb?.label?.toLowerCase()).join('>');
  }
  return null;
};

export const addFilterTypeInRefinement = (filters) => {
  return filters?.map((dimension) => ({
    ...dimension,
    refinements: dimension?.refinements?.map((refinement) => ({
      ...refinement,
      refinementKey: Number(refinement.refinementKey).toString(36),
      filterType: 'smart-filter'
    }))
  }));
};
